import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'bitcoin-cash'),
  es: flattenMessages(es, 'bitcoin-cash'),
  ru: flattenMessages(ru, 'bitcoin-cash'),
  zh: flattenMessages(zh, 'bitcoin-cash'),
};
